import apiClient from './client';

export const listTasks = (params) => apiClient.get('/tasks', { params }).then((r) => r.data);
export const getTask = (id) => apiClient.get(`/tasks/${id}`).then((r) => r.data);
export const createTask = (payload) => apiClient.post('/tasks', payload).then((r) => r.data);
export const updateTask = (id, payload) => apiClient.put(`/tasks/${id}`, payload).then((r) => r.data);
export const deleteTask = (id) => apiClient.delete(`/tasks/${id}`).then((r) => r.data);
export const addTaskComment = (id, comment) => apiClient.post(`/tasks/${id}/comments`, { comment }).then((r) => r.data);
export const addTaskAttachment = (id, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient.post(`/tasks/${id}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
